import React, { useMemo } from 'react';
import Modal from '@mui/material/Modal';
import {
  Box,
} from '@mui/material';
import { useSelector } from 'react-redux';
import DataTable from '../../Common/DataTable';
import { Cancel } from '../../media/images/Cancel';
import { Datatablestyle } from './utils/Constant';
import { AnalystTubeReportTableData } from './utils/TypeDashboard';
import { RootState } from '../../redux/rootState';
// import { PrintIcon } from '../../assets/TableIcons';

interface ISyncDownReportModal {
  open: boolean;
  handleClose: () => void;
  // handlePrinting: () => void;
}

export default function ShowAnalystReportModal({
  open, handleClose,
}: ISyncDownReportModal) {
  const { analystTubeCountReportData } = useSelector((state:RootState) => state.dashboardReducer);

  const analystTubeCountReports = useMemo(() => analystTubeCountReportData?.Result?.map((item, index) => ({
    id: String(index + 1),
    AnalystId: item?.AnalystId,
    AnalystName: item?.AnalystName,
    TubesTested: item?.TubesTested,
  })), [analystTubeCountReportData]);

  const receivedColumns = [
    { key: 'AnalystId', label: 'Analyst Id' },
    { key: 'AnalystName', label: 'Analyst Name' },
    { key: 'TubesTested', label: 'Tubes Tested' },
  ];

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={Datatablestyle}>
        <div className="customerInfo_container flex-row">
          <div className="customerInfo">
            Analyst Tube Count Report
          </div>
          <div className="cancel-icon" onClick={() => handleClose()}>
            <Cancel />
          </div>

        </div>
        <div className="customModalBtnContainer">
          {/* <div className="pointCursor" onClick={handlePrinting}>
            <PrintIcon />
          </div> */}
        </div>
        <DataTable<AnalystTubeReportTableData>
          data={analystTubeCountReports || []}
          columns={receivedColumns}
          handleData={() => {}}
          totalRecords={10}
        />
      </Box>
    </Modal>
  );
}
